import { GetDistributionOverviewMarketResponse } from '_clients/BFFClient';
import { create } from 'zustand';

export type NetworkMarketsWithDate =  {
  markets: GetDistributionOverviewMarketResponse[];
  creationDate: Date;
  networkId?: string;
  contractId?: number;
};

export type MarketStore = {
  networkMarkets: NetworkMarketsWithDate;
  setNetworkMarkets: (markets: GetDistributionOverviewMarketResponse[] , networkId: string, contractId: number) => void;
  getMarketsForNetwork: (networkId: number, marketId: number, productId: number) => GetDistributionOverviewMarketResponse[];
  getMarketsForContract: (contractId: number, marketId: number, productId: number) => GetDistributionOverviewMarketResponse[];
};

const useMarketStore = create<MarketStore>((set) => ({
    networkMarkets: { markets: [] , networkId: null, contractId: null, creationDate: null },
    setNetworkMarkets: (markets: GetDistributionOverviewMarketResponse[] , networkId: string, contractId) => set({
      networkMarkets: { markets, networkId, contractId, creationDate: new Date()}
    }),
    getMarketsForNetwork: (networkId: number, marketId: number, productId: number) => {
      return useMarketStore.getState().networkMarkets.filter(n => n.networkId == networkId).filter(m => m.id == marketId).filter(p => p.productId == productId);
    },
    getMarketsForContract: (contractId: number, marketId: number, productId: number) => {
      return useMarketStore.getState().networkMarkets.markets.filter(m => m.id == marketId).filter(p => p.productId == productId).filter(c => c.contractId == contractId);
    }
} as MarketStore));

export default useMarketStore;